import appBulkScripts from "../../views/appSettings/bulkScripts.html";
import constants from "../../core/constants";
import { getState } from "../../core/utils";

function urlsConfig($stateProvider) {
  "ngInject";

  const base = "bulk-scripts";
  const params = ["action", "page", "limit"];

  $stateProvider.state("bulkscripts", {
    url: getState(base, params),
    parent: "app",
    views: {
      view: {
        template: appBulkScripts,
      },
    },
    reloadOnSearch: false,
    data: { title: "BulkScripts" + constants.titleBase },
  });
}

export default urlsConfig;



// WEBPACK FOOTER //
// ./src/pages/bulkScripts/bulkScripts.urls.js